import { create } from 'zustand'
import { Analyse, Explanation, Goal, Interpretation, Prediction, Summary, Train } from './entities/entities';

type Store = {
    visualisation: string;
    setVisualisation: (visualisation : string) => void;
    visualisation_image: string;
    setVisualisationImage: (visualisation_image : string) => void;

    visualisationType: string;
    setVisualisationType: (visualisation : string) => void;

    code: string;
    setCode: (code : string) => void;

    creditRiskTarget: string;
    setCreditRiskTarget: (creditRiskTarget : string) => void;

    explanations: Explanation[] | null;
    setExplanations: (explanation : Explanation[] | null) => void;

    interpretations: Interpretation | null;
    setIinterpretations: (explanation : Interpretation | null) => void;

    instructions: string;
    setInstructions: (code : string) => void;

    auth:boolean;
    setAuth:(auth : boolean) => void;

    summary:Summary | null;
    setSummary:(summary : Summary | null) => void;

    selectedGoal: Goal | null;
    setSelectedGoal:(selectedGoal: Goal | null) => void;

    goals: Goal[] | null;
    setGoals:(goals: Goal[] | null) => void;

    selectedFileName: string | null;
    setSelectedFileName: (selectedFileName: string | null) => void;

    analyse:Analyse | null;
    setAnalyse:(analyse : Analyse | null) => void;

    prediction:Prediction | null;
    setPrediction:(prediction : Prediction | null) => void;

    train:Train | null;
    setTrain:(train : Train | null) => void;    

    userFilesNames:string[] | null;
    setUserFilesNames:(userFilesNames : string[] | null) => void;  

    showPaymentModal:boolean;
    setShowPaymentModal:(showPaymentModal : boolean) => void;

    // Add these new properties for history navigation
    selectedHistoryKey: string | null;
    setSelectedHistoryKey: (key: string | null) => void;
    
    selectedHistoryData: any | null;
    setSelectedHistoryData: (data: any | null) => void;
    
    visualizationHistory: any[];
    setVisualizationHistory: (history: any[]) => void;
    
    currentHistoryIndex: number;
    setCurrentHistoryIndex: (index: number) => void;
  }
  
export const useStore = create<Store>()((set) => ({
    visualisation: '',
    setVisualisation: (visualisation) => set((state) => ({ visualisation: visualisation  })),
    visualisation_image: '',
    setVisualisationImage: (visualisation_image) => set((state) => ({ visualisation_image: visualisation_image  })),
    visualisationType: '',
    setVisualisationType: (visualisationType) => set((state) => ({ visualisationType: visualisationType  })),

    code: '',
    setCode: (code) => set((state) => ({ code: code  })),

    creditRiskTarget: '',
    setCreditRiskTarget: (creditRiskTarget:string) => set((state) => ({ creditRiskTarget: creditRiskTarget  })),

    explanations: null,
    setExplanations: (explanations:Explanation[]| null) => set((state) => ({ explanations: explanations  })),

    interpretations: null,
    setIinterpretations: (interpretations) => set((state) => ({ interpretations: interpretations  })),

    instructions: '',
    setInstructions: (instructions) => set((state) => ({ instructions: instructions  })),

    auth: !!localStorage.getItem("tokenLida"),
    setAuth: (auth) => set((state) => ({ auth: auth  })),

    summary: null,
    setSummary:(summary) => set((state) => ({ summary: summary  })),

    analyse: null,
    setAnalyse:(analyse) => set((state) => ({ analyse: analyse  })),

    prediction: null,
    setPrediction:(prediction) => set((state) => ({ prediction: prediction  })),

    train: null,
    setTrain:(train) => set((state) => ({ train: train  })),

    selectedGoal: null,
    setSelectedGoal:(selectedGoal) => set((state) => ({ selectedGoal: selectedGoal  })),

    goals: null,
    setGoals:(goals) => set((state) => ({ goals: goals  })),

    selectedFileName:null,
    setSelectedFileName:(selectedFileName) => set((state) => ({ selectedFileName: selectedFileName  })),

    userFilesNames:null,
    setUserFilesNames:(userFilesNames) => set((state) => ({ userFilesNames: userFilesNames  })),

    showPaymentModal:false,
    setShowPaymentModal:(showPaymentModal) => set((state) => ({ showPaymentModal: showPaymentModal  })),
    
    // Implementation for new history navigation properties
    selectedHistoryKey: null,
    setSelectedHistoryKey: (key) => set(() => ({ selectedHistoryKey: key })),
    
    selectedHistoryData: null,
    setSelectedHistoryData: (data) => set(() => ({ selectedHistoryData: data })),
    
    visualizationHistory: [],
    setVisualizationHistory: (history) => set(() => ({ visualizationHistory: history })),
    
    currentHistoryIndex: -1,
    setCurrentHistoryIndex: (index) => set(() => ({ currentHistoryIndex: index })),
  }));